import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { motion } from "framer-motion";
import api, { fileUrl } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import ProductCard from "@/components/ProductCard";
import VerifiedBadge from "@/components/VerifiedBadge";
import { Loader2, Package, TrendingUp, Calendar } from "lucide-react";

export default function SellerProfile() {
  const { id } = useParams();
  const { t } = useI18n();
  const [data, setData] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get(`/sellers/${id}`).then((r) => setData(r.data)).catch(() => setData(false));
  }, [id]);

  if (!data) return <div className="max-w-7xl mx-auto px-5 py-32 flex justify-center"><Loader2 className="h-6 w-6 animate-spin text-[#0EA5E9]" /></div>;
  const s = data.seller;
  const since = s.member_since ? new Date(s.member_since).getFullYear() : "";

  return (
    <div>
      <div className="relative overflow-hidden bg-[#0F172A] grain">
        <div className="absolute -bottom-20 right-10 h-64 w-64 rounded-full bg-[#0EA5E9]/30 blur-3xl" />
        <div className="relative max-w-7xl mx-auto px-5 py-14 flex flex-col sm:flex-row items-start sm:items-center gap-6">
          {s.avatar_url ? (
            <img src={fileUrl(s.avatar_url)} alt={s.display_name} className="h-24 w-24 rounded-3xl object-cover border-2 border-white/20" />
          ) : (
            <div className="h-24 w-24 rounded-3xl bg-[#0EA5E9] text-white text-3xl font-extrabold flex items-center justify-center">{s.display_name[0]}</div>
          )}
          <div>
            <div className="flex items-center gap-2">
              <h1 className="font-display text-3xl md:text-4xl font-extrabold text-white">{s.display_name}</h1>
              {s.verified && <VerifiedBadge size={22} />}
            </div>
            {s.headline && <p className="text-slate-300 mt-1">{s.headline}</p>}
            <div className="flex gap-5 mt-4 text-sm text-slate-300">
              <span className="flex items-center gap-1.5"><Package className="h-4 w-4 text-[#0EA5E9]" /> {s.total_products} {t("seller.products")}</span>
              <span className="flex items-center gap-1.5"><TrendingUp className="h-4 w-4 text-[#0EA5E9]" /> {s.total_sales} {t("seller.sales")}</span>
              {since && <span className="flex items-center gap-1.5"><Calendar className="h-4 w-4 text-[#0EA5E9]" /> {t("seller.since")} {since}</span>}
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 py-12">
        {s.bio && <p className="text-[#475569] leading-relaxed max-w-2xl mb-10">{s.bio}</p>}
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {data.products.map((p, i) => <ProductCard key={p.id} product={{ ...p, seller_name: s.display_name, seller_avatar: s.avatar_url }} index={i} />)}
        </div>
      </div>
    </div>
  );
}
